export default "__VITE_ASSET__128cdd0a__"